/**
 * Shared guards for source/sink edit flows that use vendor endpoints.
 *
 * The rule is simple: if the resource (source or sink) has a non-null
 * vendor_endpoint or vendor_endpoint_id at its root, the form needs
 * vendor endpoint spec data before it can render the endpoint dropdown
 * correctly. Otherwise, proceed immediately.
 */

/**
 * Returns true if the resource has a vendor endpoint ID at its root,
 * meaning it needs vendor endpoint spec data to render correctly.
 * Works for both sources and sinks, any connector category.
 */
export function hasVendorEndpoint(resource) {
  if (!resource) return false;
  return resource.vendor_endpoint != null || resource.vendor_endpoint_id != null;
}

/**
 * Returns true if vendor_endpoint or vendor_endpoint_id just transitioned
 * from absent to present between the previous and next versions of the
 * resource. Used in componentDidUpdate to detect when endpoint data
 * arrives after initial load (race condition).
 */
export function didVendorEndpointJustArrive(prevResource, nextResource) {
  if (!nextResource) return false;
  const hadNone = !hasVendorEndpoint(prevResource);
  const hasNow = hasVendorEndpoint(nextResource);
  return hadNone && hasNow;
}
